import { PackageSecurityServerAssignmentGridController } from '../controller/PackageSecurityServerAssignmentGridController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { DeepPartial } from 'typeorm';
import { PackageData, ScanServers } from '../../../types/package-data';
import { Observable } from 'rxjs';
import { SchemaSVA } from '../types';

export class PackageSecurityServerAssignmentGridWebComponent extends BaseWebComponentElement {
  public controller!: PackageSecurityServerAssignmentGridController;
  private isVisible: boolean;
  private scanServers: SchemaSVA[];
  private useEncryption: boolean | undefined;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackageSecurityServerAssignmentGridController,
    });
  }

  public get value(): DeepPartial<PackageData> {
    const scanServers: Array<ScanServers> = [];

    if (this.controller.gridData.length !== 0 && this.isVisible) {
      this.controller.gridData.forEach(item => {
        scanServers.push({
          _id: item._id,
          protectedEntityId: item.protectedEntityId,
          name: item.name,
          ip: item.ip,
          customHostname: item.customHostname,
        });
      });
    }

    return {
      settings: {
        useEncryption: this.controller.view.formGroup.value['SSL'] as boolean,
        scanServers: scanServers as [],
      },
    };
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public set companyId(companyId) {
    this.setAttribute('companyId', companyId);
  }

  public get companyId(): string {
    const value = this.getAttribute('companyId');
    return value ? value : '';
  }

  public async setPackageData(packageData: PackageData): Promise<void> {
    this.scanServers = [];
    if (packageData.settings.scanServers) {
      this.scanServers = packageData.settings.scanServers as SchemaSVA[];
    }
    this.useEncryption = packageData?.settings.useEncryption;
  }

  public getUseEncryption(): boolean | undefined {
    return this.useEncryption;
  }

  public getScanServers(): SchemaSVA[] {
    return this.scanServers;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }

  public handleServerAssignmentValidators(securityServerAssignmentVisible: boolean): void {
    this.controller.view.handleSecurityServerAssignmentValidators(securityServerAssignmentVisible);
  }

  /**
   *
   * @private
   */
  public setGridValidity(isValid): void {
    this.controller.view.isGridValid = isValid;
  }

  public setVisibility(isVisible: boolean): void {
    this.isVisible = isVisible;
  }

  public async showSecurityServerAssignmentSection(isVisible: boolean, companyId: string | undefined): Promise<void> {
    await this.controller.showSecurityServerAssignmentSection(isVisible, companyId);
  }

  public async render(): Promise<void> {
    await this.controller.render();
  }
}
